import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import i18n configuration
import { setupAxiosInterceptors } from './services/authService'; // Import setupAxiosInterceptors

// Setup axios interceptors before rendering the app
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense
      fallback={
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
          {/* <img
            src="/logo_banane_transparent.png"
            alt="Logo"
            style={{
              width: '150px',
              marginBottom: '20px',
              animation: 'spin 2s linear infinite' // Add spinning animation
            }}
          /> */}
          <img
            src="/animation_loading.gif"
            alt="Loading"
            style={{
              width: '50%',
              marginBottom: '20px'
            }}
          />
          <p>Banana is Loading</p>
          <style>
            {`
              @keyframes spin {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            `}
          </style>
        </div>
      }
    >
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
